export default __webpack_public_path__ + "static/media/camera_green.b66bc142.svg";